<template>
    <FullFillBox
        :pageID="1001"
        :otherPer="[2]"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
        @otherPermission="(data) => {
            if(data[0].status === 80){
                this.exportButtonCanSpawn = true
            }
        }"
    >
        <h3>{{ $t('inventory_table') }}</h3>
        <hr>
        <div class="row g-2">
            <div class="col-lg-2">
                <button class="btn btn-primary"
                        v-if="this.exportButtonCanSpawn"
                        @click="toggleExportExcelPopUp(1)">
                    {{ $t('common_export_excel') }}
                </button>
            </div>
            <div class="col-lg-8">
                <div class="row">

                    <div class="col-md-5">
                        <div class="row">
                            <div class="col-lg-4 col-form-label">
                                {{ $t('common_start') }}
                            </div>
                            <div class="col-lg-8">
                                <input class="form-control"
                                       type="datetime-local" id="start-time"
                                       v-model="startDate"
                                       min="2022-11-01T00:00" :max="nowDataTime"
                                       @change="getBackendData">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="row">
                            <div class="col-lg-4 col-form-label">
                                {{ $t('common_end') }}
                            </div>
                            <div class="col-lg-8">
                                <input class="form-control"
                                       type="datetime-local" id="end-time"
                                       v-model="endDate"
                                       min="2022-11-01T00:00" :max="nowDataTime"
                                       @change="getBackendData">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <button class="btn btn-primary" @click="resetTimeFilter">{{ $t('common_reset') }}</button>
                    </div>
                </div>
            </div>
            <div class="col-lg-2">
                <select class="form-select" v-model="groupBy" @change="tableGroupBy">
                    <option value="no">{{ $t('inventory_table_gp_no_gp') }}</option>
                    <option value="loc">{{ $t('inventory_table_gp_loc') }}</option>
                    <option value="outCode">{{ $t('inventory_table_gp_outCode') }}</option>
                    <option value="cat">{{ $t('product_category') }}</option>
                    <option value="brand">{{ $t('product_brand') }}</option>
                    <option value="size">{{ $t('product_size_gp') }}</option>
                    <option value="color">{{ $t('product_color') }}</option>
                    <option value="material">{{ $t('product_material') }}</option>
                </select>
            </div>
        </div>
        <hr>
        <ProductFilterMultiSelect
            :mainData="mainData"
            ref="filterBar"
            v-if="mainData"
            @getFilteredData="(data) => {
                    this.tabulator.setData(data)
                    this.tabulator.redraw(true)
                }"
        />
        <hr>
        <div ref="tabulatorTableUse"></div>
        <hr>
        <h4>{{ $t('inventory_table_zero') }}</h4>
        <hr>
        <div ref="tabulatorTableForZeroUse"></div>
    </FullFillBox>

    <!--   PopupMenu Show Temp List  -->
    <vue-final-modal v-model="showExportExcelPopUp" classes="modal-container" content-class="modal-content"
                     style="margin-top: 20vh;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="toggleExportExcelPopUp(0)">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;height: auto;width: auto">
            <h4>{{ $t('inventory_table_export_excel') }}</h4>
            <p>{{ $t('inventory_table_export_excel_hit') }}</p>
            <div class="row">
                <div class="col-md-6">
                    <p>{{ $t('inventory_table_export_excel_hit_full') }}</p>
                    <button class="btn btn-primary" style="width: 200px;" @click="getExportExcel('full')">
                        {{ $t('inventory_table_export_detail_excel') }}
                    </button>
                    <div class="rap-image" style="margin: 10px">
                        <img :src="fullDetailExcelSimplePath" alt="excel_format_simple" style="height: 80%">
                    </div>
                </div>
                <div class="col-md-6">
                    <p>{{ $t('inventory_table_export_excel_hit_group') }}</p>
                    <button class="btn btn-primary" style="width: 200px;" @click="getExportExcel('group')">
                        {{ $t('inventory_table_export_grouped_excel') }}
                    </button>
                    <div class="rap-image" style="margin: 10px">
                        <img :src="groupedDetailExcelSimplePath" alt="excel_format_simple" style="height: 80%">
                    </div>
                </div>
            </div>
            <p v-if="export_error">{{ export_error }}</p>
            <p v-if="export_error_details">{{ export_error_details }}</p>
        </div>
    </vue-final-modal>

    <vue-easy-lightbox
        :visible="showPopUpImageDetails"
        :imgs="thisImageSrc"
        :index="0"
        :zoomScale=1
        @hide="showPopUpImageDetails = false">
    </vue-easy-lightbox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import VueEasyLightbox from "vue-easy-lightbox/external-css";
import {TabulatorFull as Tabulator} from "tabulator-tables";
import Multiselect from "@vueform/multiselect";
import ProductFilterMultiSelect from "@/components/ProductFilterMultiSelect.vue";

export default {
    name: "InventoryTableView",
    components: {
        FullFillBox,
        VueEasyLightbox,
        Multiselect,
        ProductFilterMultiSelect
    },
    data(){
        return{
            permissionDetails: {},
            exportButtonCanSpawn: false,
            // Pop Up Menu For Export Excel
            showExportExcelPopUp: false,

            // mainData
            mainData: [],
            mainDataForZero: [],

            startDate: '',
            endDate: '',
            nowDataTime: '',
            groupBy: 'no',

            showPopUpImageDetails: false,
            thisImageSrc: '',

            brandList: [],
            getBrand: [],
            categoryList: [],
            getCategory: [],

            tabulatorTables: [],
            tabulatorTables2: [],
            subZeroTableList: [],

            fullDetailExcelSimplePath: '',
            groupedDetailExcelSimplePath: '',

            export_error: '',
            export_error_details: '',
        }
    },
    methods: {
        async getExportExcel(flag){
            let extraPath = ""
            if(this.startDate){
                extraPath += "start=" + this.startDate
            }
            if(this.endDate){
                if(extraPath.length > 5){
                    extraPath += "&end=" + this.endDate
                }else{
                    extraPath += "end=" + this.endDate
                }
            }
            if(extraPath.length > 5){
                extraPath = "?" + extraPath
            }
            let path = ""
            if(flag === 'group'){
                path = "api/inventory/export-grouped" + extraPath
            }else{
                path = "api/inventory/export-full" + extraPath
            }
            this.$mainApi.defaults.headers.common['GL-Page-ID'] = "3";
            this.$mainApi.defaults.headers.common['GL-Action-ID'] = "1";
            await this.$mainApi.get(path)
                .then(response => {
                    this.export_error = ""
                    this.export_error_details = ""
                    if(response.data.status === 80){
                        location.href = (this.$store.state.serverIp + response.data.details)
                    }else{
                        this.export_error = response.data.errors
                        this.export_error_details = response.data.details
                        this.$toast.warning(this.$t('error_excel_export'))
                    }
                })
        },
        toggleExportExcelPopUp(flag){
            if(flag === 0){
                // close
                this.showExportExcelPopUp = false
                this.$store.commit('setIsBlackLayout', false)
            }else{
                // open
                if(this.exportButtonCanSpawn){
                    this.showExportExcelPopUp = true
                    this.$store.commit('setIsBlackLayout', true)
                }else{

                }
            }
        },
        filterSelected(){
            let nowTableData = this.mainData
            if(this.getCategory.length > 0 && this.getBrand.length > 0){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name) || this.getBrand.includes(a.brand_name))
            }
            if(this.getCategory.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name))
            }
            if(this.getBrand.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getBrand.includes(a.brand_name))
            }
            this.tabulator.setData(nowTableData)
            this.tabulator.redraw()
        },
        setTimeFilter(){
            let now = new Date();
            now.setMinutes(now.getMinutes() + 10 - now.getTimezoneOffset());
            this.nowDataTime = now.toISOString().slice(0,16);
            this.startDate = ""
            this.endDate = ""
        },
        async resetTimeFilter(){
            this.setTimeFilter()
            await this.getBackendData()
        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
        getHeaderMenuZero(){
            return this.$getHeaderMenu(this.tabulatorForZero)
        },
        tableGroupBy(){
            if(this.groupBy === "no"){
                this.tabulator.setGroupBy("")
                this.tabulator.setSort("location", "asc");
            }else if(this.groupBy === "outCode"){
                this.tabulator.setGroupBy("outCode")
                this.tabulator.setSort("outCode", "asc");
            }else if(this.groupBy === "loc"){
                this.tabulator.setGroupBy("location")
                this.tabulator.setSort("location", "asc");
            }else if(this.groupBy === "cat"){
                this.tabulator.setGroupBy("category_name")
                this.tabulator.setSort("category_name", "asc");
            }else if(this.groupBy === "brand"){
                this.tabulator.setGroupBy("brand_name")
                this.tabulator.setSort("brand_name", "asc");
            }else if(this.groupBy === "size"){
                this.tabulator.setGroupBy("size_group")
                this.tabulator.setSort("size_group", "asc");
            }else if(this.groupBy === "color"){
                this.tabulator.setGroupBy("color")
                this.tabulator.setSort("color", "asc");
            }else if(this.groupBy === "material"){
                this.tabulator.setGroupBy("material")
                this.tabulator.setSort("material", "asc");
            }
            this.tabulator.redraw()
        },
        getGroupHeader(value, count, data, group) {
            let totalQty = 0
            for( let i = 0; i<data.length; i++ ) {
                if(data[i].hasOwnProperty("qty") ) {
                    totalQty += parseFloat( data[i]['qty'] );
                }
            }
            return value + "&nbsp;&nbsp;&nbsp;" +
                "<span style='color:#d00; margin-left:10px;'>" + count + "&nbsp;"+this.$t('common_record')+"</span>" +
                "<span style='color:#002cdd; margin-left:10px;'>" + totalQty + "&nbsp;"+this.$t('common_qty')+"</span>"
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            let extraPath = `?start=${this.startDate}&end=${this.endDate}`
            await this.$mainApi.get(`api/inventory/list` + extraPath)
                .then(response => {
                    if(response.data.status === 80){
                        this.mainData = response.data.details.main
                        this.tabulator.setData(response.data.details.main)
                        this.mainDataForZero = response.data.details.sub_zero
                        this.tabulatorForZero.setData(response.data.details.sub_zero)
                    }
                })
            await this.getFilterData()
            this.$store.commit('setIsTopLoading', false)
        },
        async getFilterData(){
            await this.$mainApi.get('api/product/filter/')
                .then(response => {
                    if(response.data.status === 80){
                        // 1 -> Category, 2 -> Brand
                        this.categoryList = response.data.details[0]["1"]
                        this.brandList = response.data.details[1]["2"]
                    }
                })
        },
        closeAllSubTable(){
            let all = document.getElementsByClassName('subParent')
            for(let i=0;i<all.length;i++){
                if(all[i].style.display === "block"){
                    // block = showing
                    // Then close
                    let getID = (all[i].id).split('-')[1]
                    this.tabulatorTables = this.tabulatorTables.filter(a => a.id !== parseInt(getID))
                    document.getElementById("mainContainer" + getID).remove()

                    all[i].style.display = "none"
                }
            }
        },
    },
    async mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('inventory_table')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {
                    title: 'image',
                    formatter: "image",
                    headerHozAlign: "center",
                    hozAlign: "left",
                    resizable: false,
                    field: 'image_url',
                    width: 60,
                    responsive: 1,
                    headerSort: false,
                    headerMenu: this.getHeaderMenu,
                    formatterParams: {
                        height: "70px",
                        width: "50px",
                        urlPrefix: this.$store.state.serverIp + this.$store.state.serverMediaPath,
                        urlSuffix: "?" + new Date().getTime(),
                    },
                    cellClick: (e, cell) => {
                        this.showPopUpImageDetails = true
                        this.thisImageSrc = this.$store.state.serverIp + this.$store.state.serverMediaPath + cell.getRow().getData().image_url + "?" + new Date().getTime()
                    }
                },
                {
                    title: this.$t('table_location'), field: 'location', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_area'), field: 'area', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_qty'), field: 'qty', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_ctn'), field: 'ctn', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, width: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, width: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_category'), field: 'category_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_brand'), field: 'brand_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_name'), field: this.$store.state.language === 'en' ? 'name_en' : 'name_zh',
                    sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 4,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_size'), field: 'size_group', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_size_detail'), field: 'size_detail', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_size_remarks'), field: 'size_remarks', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_color'), field: 'color', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_material'), field: 'material', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_inner_packing'), field: 'in_pack', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_unit1', field: 'in_unit1', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_unit2', field: 'in_unit2', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_unit1', field: 'out_unit1', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_unit2', field: 'out_unit2', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'min_stock', field: 'min_stock', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_size_length', field: 'in_size_length', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_size_width', field: 'in_size_width', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_size_height', field: 'in_size_height', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_size_length', field: 'out_size_length', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_size_width', field: 'out_size_width', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_size_height', field: 'out_size_height', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'net_weight', field: 'net_weight', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'gross_weight', field: 'gross_weight', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {title: 'locID', field: 'locID', visible: false},
                {title: 'pid', field: 'pid', visible: false},
                {title: 'id', field: 'id', visible: false},
                {formatter: () => {return "<i class='bi bi-plus-circle-fill'></i>"},
                    headerHozAlign:"center", hozAlign:"center", vertAlign: "middle", resizable:false,
                    headerMenu: this.getHeaderMenu, headerClick: this.closeAllSubTable,
                    headerSort:false, width:10, responsive:0,
                    cellClick:
                        (e, row, formatterParams) => {
                            const id = row.getData().id;
                            let parent = document.getElementById("subParent-" + id + "")

                            if (parent.style.display === "none") {
                                parent.style.display = 'block'

                                let mainContainer = document.createElement("div")
                                parent.appendChild(mainContainer);
                                mainContainer.setAttribute('id', 'mainContainer'+id)
                                mainContainer.style.textAlign = "center"

                                let loading = document.createElement("div")
                                mainContainer.appendChild(loading);
                                loading.setAttribute('class', 'spinner-grow')
                                loading.setAttribute('role', 'status')
                                let extraPath = `&start=${this.startDate}&end=${this.endDate}`
                                this.$mainApi.get(`api/inventory/small-details?loc=${row.getData().locID}&pid=${row.getData().pid}`+extraPath)
                                    .then(response => {
                                        let tableEl = document.createElement("div");
                                        mainContainer.appendChild(tableEl);
                                        tableEl.style.border = "1px solid #333";
                                        tableEl.style.margin = "auto";
                                        tableEl.setAttribute('id', "subTableID-" + id + "");
                                        tableEl.setAttribute('class', "subTable");

                                        loading.remove()

                                        this.subTable = new Tabulator(tableEl, {
                                            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                                            height: 'auto',
                                            responsiveLayout: 'collapse',
                                            layout: "fitColumns",
                                            movableColumns: true,
                                            movableRows: false,
                                            pagination:"local",
                                            paginationSize:10,
                                            paginationSizeSelector:[5, 10, 20],
                                            paginationCounter:"rows",
                                            data: response.data.details,
                                            columns: [
                                                {
                                                    responsive:5, width: 150,
                                                    title: this.$t('table_create_date'),
                                                    field: "createDate",
                                                    sorter: "string",
                                                    headerFilter:"input",
                                                    headerFilterParams:{
                                                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                                    },
                                                },
                                                {
                                                    responsive:5, width: 150,
                                                    title: this.$t('table_ip'),
                                                    field: "ip",
                                                    sorter: "string",
                                                    headerFilter:"input",
                                                    headerFilterParams:{
                                                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                                    },
                                                },
                                                {
                                                    responsive:5, width: 100,
                                                    title: this.$t('table_show_name'),
                                                    field: "show_name",
                                                    sorter: "string",
                                                    headerFilter:"input",
                                                    headerFilterParams:{
                                                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                                    },
                                                },
                                                {
                                                    responsive:5, minWidth: 100,
                                                    title: this.$t('table_action'),
                                                    field: "actionCode",
                                                    sorter: "string",
                                                    headerFilter:"list",
                                                    headerFilterParams:{
                                                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                                    },
                                                    formatter: (cell, formatterParams, onRendered) => {
                                                        if(cell.getValue() === 1){
                                                            return "<span style='color: #11e100'>" + this.$t('table_stock_in') + "</span>"
                                                        }if(cell.getValue() === 2){
                                                            return "<span style='color: #eb2525'>" + this.$t('table_stock_out') + "</span>"
                                                        }if(cell.getValue() === 3){
                                                            return "<span style='color: #11e100'>" + this.$t('table_stock_tran_in') + "</span>"
                                                        }if(cell.getValue() === 4){
                                                            return "<span style='color: #eb2525'>" + this.$t('table_stock_tran_out') + "</span>"
                                                        }if(cell.getValue() === 5){
                                                            return "<span style='color: #eb2525'>" + this.$t('table_stock_write') + "</span>"
                                                        }if(cell.getValue() === 6){
                                                            return "<span style='color: #000000'>" + this.$t('table_stock_adjust') + "</span>"
                                                        }
                                                    },
                                                },
                                                {
                                                    widthGrow:1, responsive:3, minWidth: 200,
                                                    title: this.$t('table_key'),
                                                    field: "keyName",
                                                    sorter: "string",
                                                    headerFilter:"input",
                                                    headerFilterParams:{
                                                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                                    },
                                                    formatter: (cell, formatterParams, onRendered) => {
                                                        return "<span style='color: #ff0000'>" + cell.getValue() + "</span>"
                                                    },
                                                    cellDblClick:(e, row, formatterParams) => {
                                                        const po_id = row.getData().po_id
                                                        let newLink = '/inventory/po/' + po_id
                                                        this.$router.push(newLink)
                                                    },
                                                },
                                                {
                                                    widthGrow:1, responsive:3, minWidth: 200,
                                                    title: this.$t('table_key_remarks'),
                                                    field: "keyRemarks",
                                                    sorter: "string",
                                                    headerFilter:"input",
                                                    headerFilterParams:{
                                                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                                    },
                                                },
                                                {
                                                    width:100, responsive:0,
                                                    title: this.$t('table_qty'),
                                                    field: "qty",
                                                    sorter: "number",
                                                    headerFilter:"input",
                                                    headerFilterParams:{
                                                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                                    },
                                                },
                                                {field: "keyID", visible: false},
                                                {field: "hisID", visible: false},
                                                {field: "actionCode", visible: false},
                                                {
                                                    formatter: (cell, formatterParams, onRendered) => {
                                                        return "<i class='bi bi-plus-circle-fill'></i>"
                                                        // let data = cell.getRow(cell).getData().actionCode
                                                        // if(data === 1 || data === 2){
                                                        //     return "<i class='bi bi-plus-circle-fill'></i>"
                                                        // }
                                                    },
                                                    headerHozAlign: "center",
                                                    hozAlign: "center",
                                                    vertAlign: "middle",
                                                    resizable: false,
                                                    headerSort: false,
                                                    width: 10,
                                                    responsive: 0,
                                                    cellClick:
                                                        (e, row, formatterParams) => {
                                                            // if(row.getData().actionCode === 1 || row.getData().actionCode === 2){
                                                            const id = row.getData().hisID;
                                                            let parent = document.getElementById("subParent2-" + id + "")

                                                            if (parent.style.display === "none") {
                                                                parent.style.display = 'block'

                                                                let mainContainer = document.createElement("div")
                                                                parent.appendChild(mainContainer);
                                                                mainContainer.setAttribute('id', 'mainContainer2' + id)
                                                                mainContainer.style.textAlign = "center"

                                                                let loading = document.createElement("div")
                                                                mainContainer.appendChild(loading);
                                                                loading.setAttribute('class', 'spinner-grow')
                                                                loading.setAttribute('role', 'status')

                                                                let tableEl = document.createElement("div");
                                                                mainContainer.appendChild(tableEl);
                                                                tableEl.style.border = "1px solid #333";
                                                                tableEl.style.margin = "auto";
                                                                tableEl.setAttribute('id', "subTableID2-" + id + "");
                                                                tableEl.setAttribute('class', "subTable2");

                                                                loading.remove()

                                                                let rowColor = ""
                                                                let getColumn = []
                                                                let getData = []
                                                                if(row.getData().actionCode === 1){
                                                                    rowColor = "#dbffaf"
                                                                    getColumn = [
                                                                        {
                                                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                                                            title: this.$t('table_remarks'),
                                                                            field: "remarks",
                                                                        },
                                                                        {
                                                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                                                            title: this.$t('table_lot_no'),
                                                                            field: "lot_no",
                                                                            formatter: (cell, formatterParams, onRendered) => {
                                                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                                                }else{
                                                                                    return cell.getValue()
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                                                            title: this.$t('table_origin'),
                                                                            field: "origin",
                                                                            formatter: (cell, formatterParams, onRendered) => {
                                                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                                                }else{
                                                                                    return cell.getValue()
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                                                            title: this.$t('table_cost'),
                                                                            field: "cost",
                                                                            formatter: (cell, formatterParams, onRendered) => {
                                                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                                                }else{
                                                                                    return "<span style='color: #000000'>$&nbsp;" + cell.getValue() + "</span>"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            widthGrow: 1, responsive: 0, minWidth: 100,
                                                                            title: this.$t('table_receive'),
                                                                            field: "receiveDate",
                                                                            formatter: (cell, formatterParams, onRendered) => {
                                                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                                                }else{
                                                                                    return cell.getValue()
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            widthGrow: 1, responsive: 0, minWidth: 100,
                                                                            title: this.$t('table_expiry'),
                                                                            field: "expiryDate",
                                                                            formatter: (cell, formatterParams, onRendered) => {
                                                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                                                }else{
                                                                                    return cell.getValue()
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                    getData.push({
                                                                        "remarks": row.getData().remarks,
                                                                        "lot_no": row.getData().lot_no,
                                                                        "origin": row.getData().origin,
                                                                        "cost": row.getData().cost,
                                                                        "receiveDate": row.getData().receiveDate,
                                                                        "expiryDate": row.getData().expiryDate
                                                                    })
                                                                }else if(row.getData().actionCode === 2){
                                                                    rowColor = "#bbd0ff"
                                                                    getColumn = [
                                                                        {
                                                                        widthGrow: 1, responsive: 3, minWidth: 100,
                                                                        title: this.$t('table_remarks'),
                                                                        field: "remarks",
                                                                        },
                                                                        {
                                                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                                                            title: this.$t('table_stock_out_date'),
                                                                            field: "lot_no",
                                                                            formatter: (cell, formatterParams, onRendered) => {
                                                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                                                }else{
                                                                                    return cell.getValue()
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                                                            title: this.$t('table_stock_out_driver'),
                                                                            field: "origin",
                                                                            formatter: (cell, formatterParams, onRendered) => {
                                                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                                                }else{
                                                                                    return cell.getValue()
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                                                            title: this.$t('table_stock_out_department'),
                                                                            field: "cost",
                                                                            formatter: (cell, formatterParams, onRendered) => {
                                                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                                                }else{
                                                                                    return "<span style='color: #000000'>" + cell.getValue() + "</span>"
                                                                                }
                                                                            }
                                                                        },
                                                                    ]
                                                                    getData.push({
                                                                        "remarks": row.getData().remarks,
                                                                        "lot_no": row.getData().lot_no,
                                                                        "origin": row.getData().origin,
                                                                        "cost": row.getData().cost,
                                                                    })
                                                                }else if(row.getData().actionCode === 3 || row.getData().actionCode === 4){
                                                                    rowColor = "#ffdfbb"
                                                                    getColumn = [
                                                                        {
                                                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                                                            title: this.$t('table_remarks'),
                                                                            field: "remarks",
                                                                        },
                                                                    ]
                                                                    getData.push({
                                                                        "remarks": row.getData().remarks,
                                                                    })
                                                                }else if(row.getData().actionCode === 5){
                                                                    rowColor = "#f4c9ff"
                                                                    getColumn = [
                                                                        {
                                                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                                                            title: this.$t('table_remarks'),
                                                                            field: "remarks",
                                                                        },
                                                                    ]
                                                                    getData.push({
                                                                        "remarks": row.getData().remarks,
                                                                    })
                                                                }else if(row.getData().actionCode === 6){
                                                                    rowColor = "#fff0c9"
                                                                    getColumn = [
                                                                        {
                                                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                                                            title: this.$t('table_remarks'),
                                                                            field: "remarks",
                                                                        },
                                                                    ]
                                                                    getData.push({
                                                                        "remarks": row.getData().remarks,
                                                                    })
                                                                }

                                                                this.subTable2 = new Tabulator(tableEl, {
                                                                    placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                                                                    maxHeight: '20vh',
                                                                    responsiveLayout: 'collapse',
                                                                    layout: "fitColumns",
                                                                    movableColumns: true,
                                                                    movableRows: false,
                                                                    rowFormatter: (row, e) => {
                                                                        row.getElement().style.backgroundColor = rowColor
                                                                    },
                                                                    data: getData,
                                                                    columns: getColumn,
                                                                })

                                                                this.tabulatorTables2.push(
                                                                    {
                                                                        "hisId": id,
                                                                        "table": this.subTable2
                                                                    }
                                                                )
                                                            }else{
                                                                this.tabulatorTables2 = this.tabulatorTables2.filter(a => a.hisId !== parseInt(id))
                                                                document.getElementById("mainContainer2" + id).remove()
                                                                parent.style.display='none'
                                                            }
                                                        }
                                                }
                                            ],
                                            rowFormatter: (row, e) => {
                                                if (row.getData().actionCode === 1) {
                                                    row.getElement().style.backgroundColor = "#dbffaf"
                                                }
                                                if (row.getData().actionCode === 2) {
                                                    row.getElement().style.backgroundColor = "#bbd0ff"
                                                }
                                                if (row.getData().actionCode === 3 && row.getData().qty > 0) {
                                                    row.getElement().style.backgroundColor = "#ffedb4"
                                                }
                                                if (row.getData().actionCode === 4 && row.getData().qty < 0) {
                                                    row.getElement().style.backgroundColor = "#ffd6d6"
                                                }
                                                if (row.getData().actionCode === 5) {
                                                    row.getElement().style.backgroundColor = "#f4c9ff"
                                                }
                                                if (row.getData().actionCode === 6) {
                                                    row.getElement().style.backgroundColor = "#fff0c9"
                                                }
                                                //create and style holder elements
                                                let holderEl = document.createElement("div");

                                                const subTableHis = row.getData().hisID;

                                                holderEl.style.display = "none";
                                                holderEl.style.boxSizing = "border-box";
                                                holderEl.style.padding = "10px 10px 10px 10px";
                                                holderEl.style.borderTop = "1px solid #333";
                                                holderEl.style.borderBotom = "1px solid #333";
                                                holderEl.style.width = "90vw";
                                                holderEl.style.background = "#ffffff";

                                                holderEl.setAttribute('id', "subParent2-" + subTableHis + "");
                                                holderEl.setAttribute('class', "subParent2");

                                                row.getElement().appendChild(holderEl);
                                            }
                                        })
                                        this.tabulatorTables.push(
                                            {
                                                "id": id,
                                                "table": this.subTable
                                            }
                                        )
                                    })
                                    .catch(errors => {
                                        // cannot connect to server
                                        this.$swal.fire({
                                            title: this.$t('main_page_error_licenceChecker_error_no_network'),
                                            text: this.$t('main_page_error_licenceChecker_error_detail') + errors,
                                            icon: 'warning',
                                        })
                                    })
                            }else{
                                this.tabulatorTables = this.tabulatorTables.filter(a => a.id !== parseInt(id))
                                document.getElementById("mainContainer" + id).remove()
                                parent.style.display='none'
                            }
                        },
                },
            ],
            reactiveData: true, //enable data reactivity
            height: '90vh',
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            groupStartOpen: false,
            groupHeader: this.getGroupHeader,
            rowFormatter: (row, e) => {
                //create and style holder elements
                let holderEl = document.createElement("div");

                const id = row.getData().id;

                holderEl.style.display = "none";
                holderEl.style.boxSizing = "border-box";
                holderEl.style.padding = "10px 10px 10px 10px";
                holderEl.style.borderTop = "1px solid #333";
                holderEl.style.borderBotom = "1px solid #333";
                holderEl.style.width = "91vw";
                holderEl.style.background = "#ffffff";

                holderEl.setAttribute('id', "subParent-" + id + "");
                holderEl.setAttribute('class', "subParent");

                row.getElement().appendChild(holderEl);

                // https://github.com/olifolkerd/tabulator/issues/3870
                // subTable DO NOT support responsive

                // subTable Code
                // https://jsfiddle.net/ustvnz5a/2/
                // https://stackoverflow.com/questions/55944754/show-hide-or-toggle-nested-table-child-in-tabulator
            },
        })
        this.tabulatorForZero = new Tabulator(this.$refs.tabulatorTableForZeroUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter: 'rownum', responsive: 0, width: 50},
                {
                    title: 'last action', field: 'action_name', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'last key', field: 'key_name', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'last active', field: 'last_activate_date', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_qty'), field: 'qty', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'ctn', field: 'ctn', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, width: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_name'), field: 'name_en', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 4,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_category'), field: 'category_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_brand'), field: 'brand_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'size', field: 'size_group', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Size Detail', field: 'size_detail', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Size Remarks', field: 'size_remarks', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_color'), field: 'color', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'material', field: 'material', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_pack', field: 'in_pack', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_unit1', field: 'in_unit1', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_unit2', field: 'in_unit2', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_unit1', field: 'out_unit1', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_unit2', field: 'out_unit2', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'min_stock', field: 'min_stock', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_size_length', field: 'in_size_length', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_size_width', field: 'in_size_width', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'in_size_height', field: 'in_size_height', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_size_length', field: 'out_size_length', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_size_width', field: 'out_size_width', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'out_size_height', field: 'out_size_height', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'net_weight', field: 'net_weight', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'gross_weight', field: 'gross_weight', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {field: 'main_id', visible: false},
                {field: 'actionCode', visible: false},
                {formatter: () => {return "<i class='bi bi-plus-circle-fill'></i>"},
                    headerHozAlign:"center", hozAlign:"center", vertAlign: "middle", resizable:false,
                    headerMenu: this.getHeaderMenuZero, headerClick: this.closeAllSubTable,
                    headerSort:false, width:10, responsive:0,
                    cellClick:
                        (e, row, formatterParams) => {
                            const id = row.getData().main_id;
                            let parent = document.getElementById("subZeroParent-" + id + "")

                            if (parent.style.display === "none") {
                                parent.style.display = 'block'

                                let mainContainer = document.createElement("div")
                                parent.appendChild(mainContainer);
                                mainContainer.setAttribute('id', 'mainZeroContainer'+id)
                                mainContainer.style.textAlign = "center"

                                let loading = document.createElement("div")
                                mainContainer.appendChild(loading);
                                loading.setAttribute('class', 'spinner-grow')
                                loading.setAttribute('role', 'status')

                                let tableEl = document.createElement("div");
                                mainContainer.appendChild(tableEl);
                                tableEl.style.border = "1px solid #333";
                                tableEl.style.margin = "auto";
                                tableEl.setAttribute('id', "subZeroTableID-" + id + "");
                                tableEl.setAttribute('class', "subZeroTable");

                                loading.remove()

                                let rowColor = ""
                                let getColumn = []
                                let getData = []
                                if(row.getData().actionCode === 1){
                                    rowColor = "#dbffaf"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "key_remarks",
                                        },
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_lot_no'),
                                            field: "lot_no",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                            title: this.$t('table_origin'),
                                            field: "origin",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                            title: this.$t('table_cost'),
                                            field: "cost",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return "<span style='color: #000000'>$&nbsp;" + cell.getValue() + "</span>"
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 0, minWidth: 100,
                                            title: this.$t('table_receive'),
                                            field: "receiveDate",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 0, minWidth: 100,
                                            title: this.$t('table_expiry'),
                                            field: "expiryDate",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        }
                                    ]
                                    getData.push({
                                        "remarks": row.getData().key_remarks,
                                        "lot_no": row.getData().lot_no,
                                        "origin": row.getData().origin,
                                        "cost": row.getData().cost,
                                        "receiveDate": row.getData().receiveDate,
                                        "expiryDate": row.getData().expiryDate
                                    })
                                }else if(row.getData().actionCode === 2){
                                    rowColor = "#bbd0ff"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "key_remarks",
                                        },
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_stock_out_date'),
                                            field: "lot_no",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                            title: this.$t('table_stock_out_driver'),
                                            field: "origin",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                            title: this.$t('table_stock_out_department'),
                                            field: "cost",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return "<span style='color: #000000'>" + cell.getValue() + "</span>"
                                                }
                                            }
                                        },
                                    ]
                                    getData.push({
                                        "remarks": row.getData().key_remarks,
                                        "lot_no": row.getData().lot_no,
                                        "origin": row.getData().origin,
                                        "cost": row.getData().cost,
                                    })
                                }else if(row.getData().actionCode === 3 || row.getData().actionCode === 4){
                                    rowColor = "#ffdfbb"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "key_remarks",
                                        },
                                    ]
                                    getData.push({
                                        "remarks": row.getData().key_remarks,
                                    })
                                }else if(row.getData().actionCode === 5){
                                    rowColor = "#f4c9ff"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "key_remarks",
                                        },
                                    ]
                                    getData.push({
                                        "remarks": row.getData().key_remarks,
                                    })
                                }

                                this.subZeroTable = new Tabulator(tableEl, {
                                    placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                                    maxHeight: '20vh',
                                    responsiveLayout: 'collapse',
                                    layout: "fitColumns",
                                    movableColumns: true,
                                    movableRows: false,
                                    rowFormatter: (row, e) => {
                                        row.getElement().style.backgroundColor = rowColor
                                    },
                                    data: getData,
                                    columns: getColumn,
                                })

                                this.subZeroTableList.push(
                                    {
                                        "hisId": id,
                                        "table": this.subZeroTable
                                    }
                                )
                            }else{
                                this.subZeroTableList = this.subZeroTableList.filter(a => a.main_id !== parseInt(id))
                                document.getElementById("mainZeroContainer" + id).remove()
                                parent.style.display='none'
                            }
                        },
                },
            ],
            reactiveData: true, //enable data reactivity
            height: '50vh',
            maxHeight: '50vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            rowFormatter: (row, e) => {
                //create and style holder elements
                let holderEl = document.createElement("div");

                const id = row.getData().main_id;

                holderEl.style.display = "none";
                holderEl.style.boxSizing = "border-box";
                holderEl.style.padding = "10px 10px 10px 10px";
                holderEl.style.borderTop = "1px solid #333";
                holderEl.style.borderBotom = "1px solid #333";
                holderEl.style.width = "91vw";
                holderEl.style.background = "#ffffff";

                holderEl.setAttribute('id', "subZeroParent-" + id + "");
                holderEl.setAttribute('class', "subZeroParent");

                row.getElement().appendChild(holderEl);
            },
        })
        this.setTimeFilter()
        await this.getBackendData()

        // Only One Listener, loop though subTable
        addEventListener('resize', () => {
            let a = document.getElementsByClassName('subTable')
            for (let i = 0; i < a.length; i++) {
                let getID = (a[i].id).split('-')[1]
                try {
                    let this_table = this.tabulatorTables.filter(a => a.id === parseInt(getID))[0]['table']
                    this_table.redraw()
                } catch (e) {
                    // pass
                }
            }
            let b = document.getElementsByClassName('subTable2')
            for (let i = 0; i < b.length; i++) {
                let getID = (b[i].id).split('-')[1]
                try {
                    let this_table = this.tabulatorTables2.filter(b => b.hisId === parseInt(getID))[0]['table']
                    this_table.redraw()
                } catch (e) {
                    // pass
                }
            }
            let c = document.getElementsByClassName('subZeroTable')
            for (let i = 0; i < c.length; i++) {
                let getID = (c[i].id).split('-')[1]
                try {
                    let this_table = this.subZeroTableList.filter(c => c.hisId === parseInt(getID))[0]['table']
                    this_table.redraw()
                } catch (e) {
                    // pass
                }
            }
        })
        this.fullDetailExcelSimplePath = this.$store.state.serverIp + this.$store.state.serverMediaPath + 'website/images/export_full_detail_inventory_excel.jpg' + '?' + new Date()
        this.groupedDetailExcelSimplePath = this.$store.state.serverIp + this.$store.state.serverMediaPath + 'website/images/export_group_detail_inventory_excel.jpg' + '?' + new Date()
    }
}
</script>

<style scoped>

</style>
